export const webUrl = (value) => {
    const text = String(value || "").trim();
    if (!text) return null;
    if (/^https?:\/\//i.test(text)) return text;
    if (/^[a-z][a-z0-9+.-]*:/i.test(text)) return null;
    return `https://${text}`;
};
